interface UpdateEventScheduleModeAboutSection {
  id: UpdateEventScheduleModeAboutSectionId;
  title: string;
  description?: string;
  editAriaLabel: string;
}

export type UpdateEventScheduleModeAboutSectionId =
  | 'general'
  | 'dates-and-location'
  | 'event-access'
  | 'coordinators'
  | 'guest-registration';

export const updateEventScheduleModeAboutSections: UpdateEventScheduleModeAboutSection[] =
  [
    {
      id: 'general',
      title: 'General',
      description: 'Includes event name, type, tags, and sectors',
      editAriaLabel: 'Edit General'
    },
    {
      id: 'dates-and-location',
      title: 'Dates & Location',
      editAriaLabel: 'Edit Dates & Location'
    },
    {
      id: 'event-access',
      title: 'Event Access',
      editAriaLabel: 'Edit Event Access'
    },
    {
      id: 'coordinators',
      title: 'Coordinators',
      editAriaLabel: 'Edit Coordinators'
    },
    {
      id: 'guest-registration',
      title: 'Guest Registration',
      description:
        'Includes on-platform default status and guest portal experience',
      editAriaLabel: 'Edit Guest Registration'
    }
  ];

/** Deep-link / modal open: `?aboutSection=event-access` (stripped after the modal reads it). */
export const UPDATE_EVENT_SCHEDULE_MODE_ABOUT_SECTION_QUERY_PARAM =
  'aboutSection';

export function aboutSectionIdFromQueryParamValue(
  raw: string | undefined
): UpdateEventScheduleModeAboutSectionId | null {
  if (!raw) return null;

  const match = updateEventScheduleModeAboutSections.find(
    (section) => section.id === raw
  );

  return match ? match.id : null;
}
